import styled from 'styled-components';

export const FoodInfoPageWrapper = styled.div`
    padding: 2rem 3rem;
    width: 100%;
    min-height: 100vh;
    box-sizing: border-box;
    color: #fff;
    background: linear-gradient(180deg, #0f1115 0%, #0b0c0f 100%);
    @media (min-width: 1200px) {
        padding: 3rem 8rem;
    }
`;

export const BackButton = styled.button<{$focused?: boolean}>`
    width: 110px;
    background: none;
    border: 2px solid #3ab8ff;
    color: #fff;
    font-weight: 700;
    border-radius: 8px;
    padding: 8px 14px;
    cursor: pointer;
    transition: all 0.18s ease;
    margin-bottom: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    &:hover {
        background-color: #3ab8ff;
        color: #000;
    }

    &:focus {
        outline: 3px solid rgba(58, 184, 255, 0.22);
        transform: translateY(-1px);
    }

    ${(props) =>
        props.$focused &&
        `
    background-color: #00bfff !important;
    color: #000 !important;
    box-shadow: 0 0 12px rgba(0,191,255,0.45);
    transform: scale(1.03);
  `}
`;

export const InfoGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    margin-top: 8px;

    @media (min-width: 900px) {
        grid-template-columns: 1fr 1fr;
    }
`;

export const Card = styled.section`
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.02));
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 12px;
    padding: 25px;
    min-height: 220px;
    box-shadow: 0 6px 18px rgba(3, 3, 10, 0.6);
`;

export const Title = styled.h1`
    font-size: 2.3rem;
    margin: 0 0 10px 0;
    color: #fff;
`;

export const Meta = styled.div`
    font-size: 1.5rem;
    color: #bcdcff;
    margin-bottom: 20px;
`;

export const PositionWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 10px 0;
    font-size: 30px;
    font-weight: 700;
`;

export const Pin = styled.span`
    font-size: 35px;
    margin-right: 4px;
`;

export const Address = styled.div`
    padding-left: 4px;
    margin: 20px 0;
    font-size: 35px;
    color: #e6f7ff;
`;

export const ActionRow = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 10px;
    flex-wrap: wrap;
`;

export const ActionButton = styled.button`
    background: #1b2630;
    border: 1px solid rgba(255, 255, 255, 0.06);
    color: #cfeeff;
    padding: 8px 12px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.15s ease;

    &:hover {
        transform: translateY(-2px);
        background: #0f4f83;
        color: #fff;
    }

    &[aria-disabled='true'] {
        opacity: 0.45;
        cursor: not-allowed;
        transform: none;
    }
`;

export const MapWrapper = styled.div`
    width: 100%;
    height: 420px;
    border-radius: 10px;
    overflow: hidden;
    background: #0b0b0b;
    border: 1px solid rgba(255, 255, 255, 0.03);

    @media (min-width: 900px) {
        height: 500px;
    }
`;

export const Skeleton = styled.div<{width?: string; height?: string}>`
    width: ${(p) => p.width ?? '100%'};
    height: ${(p) => p.height ?? '18px'};
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.03));
    border-radius: 6px;
`;

export const EmptyState = styled.div`
    padding: 32px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.02);
    color: #d6d6d6;
    text-align: center;
    font-size: 1.05rem;
`;

export const Table = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 20px;
`;

export const Row = styled.div<{$focused?: boolean}>`
    margin: 15px 0;
    background-color: #3c3c3c;
    padding: 22px 28px;
    border-radius: 16px;
    cursor: pointer;
    font-size: 1.6em;
    display: grid;
    grid-template-columns: 1fr 200px 550px;
    align-items: center;
    transition:
        background-color 0.25s ease,
        transform 0.2s ease;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);

    &:hover {
        background-color: #4a4a4a;
    }

    ${(props) =>
        props.$focused &&
        `
        background-color: #1da1f2 !important;
        color: #fff !important;
        transform: scale(1.02);

        td {
            color: #fff !important;
        }
    `}

    td {
        color: #dadada;
        padding: 0;
        border: none;
    }

    /* 제목(td 첫번째) */
    td:nth-child(1) {
        font-size: 1.1em;
        font-weight: bold;
        color: #ffffff;
    }

    /* 카테고리 */
    td:nth-child(2) {
        font-size: 0.9em;
        color: #cfcfcf;
    }

    /* 주소 */
    td:nth-child(3) {
        font-size: 0.9em;
        text-align: right;
        color: #b5b5b5;
    }
`;

// export const Table = styled.table`
//     width: 100%;
//     border-collapse: collapse;
//     color: #fff;
//     font-size: 2em;
//
//     thead {
//         background-color: #222;
//         position: sticky;
//         top: 0;
//         z-index: 1;
//     }
//
//     th, td {
//         padding: 12px;
//         text-align: left;
//         border-bottom: 1px solid #333;
//     }
// `;
//
// export const Row = styled.tr<{ $focused?: boolean }>`
//     cursor: pointer;
//     transition: background-color 0.2s ease;
//
//     &:hover {
//         background-color: #1d1d1d;
//     }
//
//     ${(props) => props.$focused && `
//         background-color: #00bfff !important;
//         color: #000 !important;
//         font-weight: bold;
//
//         td {
//             background-color: #00bfff;
//             color: #000;
//         }
//     `}
// `;
